<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <div class="navbar-brand text-capitalize" href="javascript:void(0)">Admin Report ({{type}})</div>

      <div class="d-flex flex-row gap-3 align-items-center">
        <strong>Select Date</strong>
        <input type="date" [(ngModel)]="date" (change)="inputchange()" [max]="today" class="form-control w-auto" />
      </div>
<!--       
      <mat-form-field class="ms-auto" appearance="fill">
          <mat-label>Choose a date</mat-label>
          <input matInput [max]="today" [matDatepicker]="picker" [(ngModel)]="date" (dateChange)="inputchange()">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
      </mat-form-field> -->
    </div>
  </nav>
  <hr class="mt-0"/>
  <app-table #history></app-table>